/** @jsxImportSource @emotion/react */

import React from 'react'
import { Icon, TextField } from '@components/atoms'
import { TextFieldProps } from '@mui/material/TextField'
import { grey } from '@mui/material/colors'

type PropsType = TextFieldProps & {
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const SearchTextField = (props: PropsType) => {
	// state
	const [searchKeyword, setSearchKeyword] = React.useState<string>('')
	const [event, setEvent] = React.useState<any>(null)
	const [submitText, setSubmitText] = React.useState<string>('')

	React.useEffect(() => {
		const timeout = setTimeout(() => {
			if (searchKeyword !== submitText) {
				onSubmit(event as React.ChangeEvent<HTMLInputElement>)
			}
		}, 1000)

		return () => clearTimeout(timeout)
	}, [searchKeyword, submitText])

	const onChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		const str = e.target.value

		setSearchKeyword(str)
		setEvent(e)
	}, [])

	const onInputEnterSubmit = React.useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				if (searchKeyword !== submitText) {
					onSubmit(event as React.ChangeEvent<HTMLInputElement>)
				}
			}
		},
		[event, searchKeyword, submitText],
	)

	const onSubmit = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			if (searchKeyword !== submitText) {
				if (props.onChange) {
					props.onChange(e)
					setSubmitText(searchKeyword)
				}
			}
		},
		[searchKeyword, submitText, props.onChange],
	)

	return (
		<TextField
			{...props}
			defaultValue={props.defaultValue}
			type={props.type ?? 'text'}
			label={props.label ?? '검색'}
			margin={props.margin ?? 'dense'}
			onKeyUp={onInputEnterSubmit}
			onChange={onChange}
			size={props.size ?? 'small'}
			InputProps={{
				startAdornment: <Icon name="magnify" css={{ color: grey[400] }} />,
			}}
		/>
	)
}
